'use client';

import React, { useEffect, useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa6';

const isBrowser = typeof window !== 'undefined';

export default function InputNumber({ id, defaultValue = '0', changeInput, error, min = 0 }) {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const handleIncrement = () => {
        setValue((prevValue) => parseInt(prevValue) + 1);
        changeInput(parseInt(value) + 1);
    };

    const handleDecrement = () => {
        if (parseInt(value) > min) {
            setValue((prevValue) => parseInt(prevValue) - 1);
            changeInput(parseInt(value) - 1);
        }
    };

    const handelChange = (e) => {
        e.persist();
        const { name, value } = e.target;
        // Ensure value is not less than minimum
        const newValue = Math.max(min, parseInt(value) || min);
        setValue(newValue.toString());
        changeInput(newValue);
    };

    return (
        <div className="py-2 px-3 w-full bg-white border border-gray-200 rounded-lg dark:bg-neutral-900 dark:border-neutral-700">
            <div className="relative w-full flex justify-between items-center gap-x-3" data-hs-input-number="">
                <div className="w-full">
                    <input
                        onChange={handelChange}
                        id={id}
                        className="p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
                        type="number"
                        value={value}
                        min={min}
                        onBlur={(e) => {
                            if (parseInt(e.target.value) < min) {
                                setValue(min.toString());
                                changeInput(min);
                            }
                        }}
                    />
                </div>
                <div className="flex justify-end items-center gap-x-1.5 absolute right-0">
                    <button
                        type="button"
                        onClick={handleDecrement}
                        className={`size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-full border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 ${
                            parseInt(value) <= min ? 'opacity-50 pointer-events-none' : ''
                        } dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800`}
                        data-hs-input-number-decrement=""
                        disabled={parseInt(value) <= min}
                    >
                        <FaMinus className="flex-shrink-0 size-3.5" />
                    </button>
                    <button
                        type="button"
                        onClick={handleIncrement}
                        className="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-full border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800"
                        data-hs-input-number-increment=""
                    >
                        <FaPlus className="flex-shrink-0 size-3.5" />
                    </button>
                </div>
            </div>
        </div>
    );
}
